import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const LABELS = {
  dashboard: "Dashboard", tickets: "Tickets", machines: "My machines", community: "Community", fixes: "Known fixes",
  "for-sale": "For sale", messages: "Messages", payments: "Payments", approvals: "Approvals", customers: "Customers",
  staff: "Engineers", audit: "Audit log", widget: "Website widget", new: "New", edit: "Edit",
};

const idLabel = (segment, parent) => {
  const short = `#${segment.slice(-6).toUpperCase()}`;
  return parent === "for-sale" ? `Listing ${short}` : short;
};

export const Breadcrumb = ({ prefix = "topbar" }) => {
  const segments = useLocation().pathname.split("/").filter(Boolean);
  const crumbs = segments.map((seg, i) => ({
    to: "/" + segments.slice(0, i + 1).join("/"),
    label: LABELS[seg] || (/^[0-9a-f]{24}$/i.test(seg) ? idLabel(seg, segments[i - 1]) : seg),
    last: i === segments.length - 1,
  }));
  return (
    <nav aria-label="Breadcrumb" className="flex min-w-0 items-center gap-2 whitespace-nowrap font-heading text-sm font-bold uppercase tracking-[0.3em] sm:text-base" data-testid={`${prefix}-breadcrumb`}>
      <Link to="/" data-testid={`${prefix}-title`} className="text-white">Support <span className="text-rose-500">Centre</span></Link>
      {crumbs.map((c) => (
        <span key={c.to} className="flex min-w-0 items-center gap-2">
          <ChevronRight className="h-3.5 w-3.5 flex-none text-slate-600" />
          {c.last ? (
            <span className="truncate text-xs tracking-[0.2em] text-slate-300 sm:text-sm" data-testid={`${prefix}-crumb-current`}>{c.label}</span>
          ) : (
            <Link to={c.to} className="truncate text-xs tracking-[0.2em] text-slate-500 hover:text-white sm:text-sm">{c.label}</Link>
          )}
        </span>
      ))}
    </nav>
  );
};
